export function triggerDownload(url: string, filename = ''): void {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  try {
    triggerDownload(url, filename)
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }
}
